import { images } from './images';

export const CompanyInfo = {
	address: 'company.address',
	email:   'sample@gmail.com',
	phone:   '01-23456789',

	socialMedia: [
		{
			href:  'https://www.facebook.com/plusup.recruit',
			image: images.logo.facebook,
		},
		{
			href:  'https://www.instagram.com/plusup.recruit',
			image: images.logo.instagram,
		},
		{
			href:  'https://line.me/ti/p/@plusup.recruit',
			image: images.logo.line,
		},
	],
} as const;
